import type React from "react"
import styled from "styled-components"

interface PropertyButtonProps {
  action: () => void
  children: React.ReactNode
  selected?: boolean
}

// The main button component with conditional styling based on selected state
const StyledButton = styled.button<{ $selected?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  width: 160px;
  height: 160px;
  background-color: ${(props) => (props.$selected ? "#e7f7ee" : "white")};
  //background-color: white;
  border: 1px solid #4caf8a;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  gap: 8px;
  box-shadow: ${({ $selected }) => $selected ? '0 2px 8px rgba(0, 0, 0, 0.3)' : 'none'};
  color: ${(props) => (props.$selected ? "#4caf8a" : "#555")};
  font-size: 14px;
  font-weight: 500;
  &:hover {
    background-color: ${(props) => (props.$selected ? "#d5f0e2" : "#f9f9f9")};
    //background-color: #e7f7ee;
    color: #4caf8a;
  }
`

export function SquareButton2({ action, selected = false, children }: PropertyButtonProps) {
  return (
    <StyledButton onClick={action} $selected={selected}>
      {children}
    </StyledButton>
  )
}

